import FormElementMixin from '../../../../../spine-appkit-vue/src/components/form/mixins/FormElementMixin';

// CONST
const TYPE_INTERNAL = 'internal';
const TYPE_INTERNAL_DIFFERENT_VERTICAL = 'internal-different-vertical';
const TYPE_EXTERNAL = 'external';

Vue.asyncComponent('cms-link-control', {
    mixins: [FormElementMixin],
    data() {
        return {
            type: this.value?.type,
            verticalId: this.value?.verticalId,
            verticalRoutingId: this.value?.verticalRoutingId,
            objectId: this.value?.objectId,
            externalLink: this.value?.externalLink ? this.value?.externalLink : {},
            openInNewTab: this.value?.openInNewTab == true,
            currentObjectBundleId: this.objectBundleId,
            showQuery: this.value?.showQuery,
            query: this.value?.query,
            showAnchor: this.value?.showAnchor,
            anchor: this.value?.anchor,
            linkTypeOptions: [
                {
                    value: TYPE_INTERNAL,
                    label: this.$t('Interne link')
                },
                {
                    value: TYPE_INTERNAL_DIFFERENT_VERTICAL,
                    label: this.$t('Interne link (andere vertical)')
                },
                {
                    value: TYPE_EXTERNAL,
                    label: this.$t('Externe link')
                }
            ]
        }
    },
    props: {
        pageBundleId:{
            type: String,
            required: true
        },
        pageDefinitionId: {
            type: String,
            required: true
        },
        workspaceBundleId:{
            type: String,
            required: true
        },
        workspaceDefinitionId: {
            type: String,
            required: true
        },
        objectBundleId: {
            type: String,
            required: false,
            default: null
        },
        objectDefinitionId: {
            type: String,
            required: true
        }
    },
    watch: {
        type() {
            this.externalLink = this.emptyLocalizedValue();
            this.verticalId = null;
            this.verticalRoutingId = null;
            this.objectId = null;
            this.updateCurrentValue();
        },
        externalLink() {
            this.updateCurrentValue();
        },
        verticalId() {
            this.verticalRoutingId = null;
            this.updateCurrentValue();
        },
        verticalRoutingId() {
            this.objectId = null;
            this.updateCurrentValue();
            this.$emit('changePage', this.verticalRoutingId);
        }
    },
    computed: {
        /**
         * Check if current type is internal
         * @returns {boolean}
         */
        isInternal() {
            return this.type === TYPE_INTERNAL;
        },
        /**
         * Check if current type is internal different vertical
         * @returns {boolean}
         */
        isExternalDifferentVertical() {
            return this.type === TYPE_INTERNAL_DIFFERENT_VERTICAL;
        },
        /**
         * Check if current type is internal
         * @returns {boolean}
         */
        isExternal() {
            return this.type === TYPE_EXTERNAL;
        },
        /**
         * Get the page autocomplete fetch params
         * @returns {{}}
         */
        pageFetchParams() {
            const params = {}

            // when we want to link to a different vertical's page we will send the verticalId width the autocomplete calls
            if (this.type === TYPE_INTERNAL_DIFFERENT_VERTICAL && this.verticalId) {
                params.verticalId = this.verticalId;
            }

            return params;
        },
    },
    methods: {
        /**
         * Update the currentValue
         */
        updateCurrentValue() {
            if(! this.verticalRoutingId && this.isEmptyExternalLink(this.externalLink)) {
                this.currentValue = null;
                return;
            }

            const value = {
                openInNewTab: this.openInNewTab,
                type: this.type,
            };

            if (this.verticalId) {
                value.verticalId = this.verticalId;
            }

            if (this.externalLink) {
                value.externalLink = this.externalLink;
            }

            if (this.verticalRoutingId) {
                value.verticalRoutingId = this.verticalRoutingId;
            }

            if (this.objectId) {
                value.objectId = this.objectId;
            }

            if (this.showQuery) {
                value.showQuery = this.showQuery;
                value.query = this.query;
            }

            if (this.showQuery) {
                value.showQuery = this.showQuery;
                value.query = this.query;
            }

            if (this.showAnchor) {
                value.showAnchor = this.showAnchor;
                value.anchor = this.anchor;
            }

            this.currentValue = value;
        },
        /**
         * Set object bundle id
         * @param objectBundleId
         */
        setObjectBundleId({objectBundleId}) {
            this.currentObjectBundleId = objectBundleId;
        },
        /**
         * Construct the empty value for the external link value wich is a localized field
         *
         * @returns {{}}
         */
        emptyLocalizedValue() {
            const out = {};

            this.$localeHandler.getLocales().forEach(locale => {
                out[locale] = null;
            });

            return out;
        },
        /**
         * Check if the given externalLink is empty
         * @param externalLink
         */
        isEmptyExternalLink(externalLink) {
            let empty = true;

            Object.keys(externalLink).forEach(key => {
                if (externalLink[key]) {
                    empty = false;
                }
            });

            return empty;
        }
    },
    mounted() {
        if (! this.anchor) {
            this.anchor = this.emptyLocalizedValue();
        }

        this.$on('updateObjectBundleId', this.setObjectBundleId);
    }
}, 'cms/form/controls/cms-link-control.html');
